class Team {

    constructor(_teamId, _request) {
        this.request = _request;
        this.teamId = _teamId;
    }

    members() {
        return this.request.fetch({method: "GET", endpoint: `team/${this.teamId}`});
    }
}

export default Team;
